import React, { useEffect } from "react";
import { Card } from "antd";
import SearchForm from "./SearchForm";
import PartDealList from "./customerSaleList";
// import {useModelDispatchers} from "../../../models";

export default function () {
    // const {
    //     getStockCheckStatusDict,
    //     getOrgDict,
    //     getWarehouseDict,
    //     getAreaDict,
    //     getShelveDict,
    //     getPositionDict,
    // } = useModelDispatchers("cmDict");

    useEffect(() => {
       
    }, []);
    return (
        <>
            <Card
                bordered={true}
                className="margin-top-8"
                style={{ display: "flex" }}
            >
                <div
                    style={{
                        margin: "8px 20px"
                    }}
                >
                    <SearchForm />
                </div>
            </Card>
            <Card
                bordered={true}
                className="margin-top-8"
            >
                <PartDealList />
            </Card>
        </>
    )
}